module.exports = "/static/assets/51b6bffe553abf33ea1939808f41ba05.gif";